import styled from "styled-components";
import SVG from "react-inlinesvg";
import { Wave1, Wave2 } from "../../Assets/icons";

export const Container = styled.main`
    display: flex;
    width: 100%;

    .container{
        align-items: flex-end;
        display: flex;
        gap: 30px;
        position: absolute;
        right: 15px;
        z-index: 10;

        top: 12%;
        right: 4%;

        @media (min-width: 720px) {
            top: 4%;
            right: 2%;
        }
        @media (orientation: landscape) and (max-width: 1080px){
            top: 6%;
            right: 4%;
        }
    }

    #equipment-marker{
        cursor: pointer;
        display: flex;
        height: 100px;
        left: 50%;
        position: absolute;
        top: 46%;
        transform: translate(-50%, 0);
        width: 120px;
    }
`;

export const ContainerMap = styled.div`
    height: 100vh; 
    position: absolute;
    width: 100%;
    z-index: 5;
    .mapboxgl-popup-content {
        width: 380px;
    } 
`;

export const ButtonContainer = styled.div`
    left: 5%;
    position: absolute;
    top: 10%;
    z-index: 10;
    @media (min-width: 720px) {
        left: 280px;
        top: 5%;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        left: 5%;
        top: 10%;
    }
`;

export const AccessButton = styled.button`
    align-items: center;
    background: #F6F6F6;
    border: none;
    border-radius: 10px;
    box-shadow: 0px 1.205px 1.205px 0px rgba(0, 0, 0, 0.15);
    color: #333;
    cursor: pointer;
    display: flex;
    font-size: 0px;
    font-style: normal;
    font-weight: 700;
    gap: 10px;
    justify-content: center;
    line-height: normal;
    outline: none;
    padding: 10px;
    text-align: center;
    width: 60px;
    @media (min-width: 1281px) {
        font-size: 15px;
        text-decoration: normal;
        width: 160px;
    }
`;

export const ButtonsContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 20px;
    justify-content: space-between;
    margin-top: 20px;
    width: 100%;
`;

export const LastUpdateIcon = styled.img`
    height: 16px;
    width: 16px;
`;

export const LastUpdateText = styled.span`
    align-items: center;
    background: #FFF;
    border-radius: 5px;
    box-shadow: 0px 1.52px 1.52px 0px rgba(0, 0, 0, 0.25);
    color: #333;
    display: none;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    gap: 10px;
    justify-content: center;
    line-height: normal;
    padding: 6px 9px;
    text-align: center;
    @media (min-width: 720px) {
        display: flex;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        display: flex;
    }

`;

export const CaptionContainer = styled.div`
    align-items: center;
    bottom: 25px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 15px;
    height: auto;
    justify-content: flex-start;
    left: 0;
    max-width: 95%;
    position: absolute;
    z-index: 10;
    @media (min-width: 720px) {
        align-items: center;
        flex-direction: row;
        flex-wrap: nowrap;
        gap: 5px;
        height: 8%;
        justify-content: flex-start;
        left: 280px;
        padding-bottom: 0px;
    }
    @media (orientation: landscape) and (max-width: 1080px){
        left: 0;
        z-index: 10;
    }
`;

export const CaptionGroup = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 5px;
`;

export const CaptionButton = styled.button`
    background: #FFF;
    border: none;
    border-radius: 3.676px;
    box-shadow: 1.52px 1.52px 1.52px 0px rgba(0, 0, 0, 0.25);
    color: #333;
    cursor: pointer;
    display: flex;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    outline: none;
    padding: 5px;
    text-align: center;
    transition: 1s;
    @media (max-width: 720px) {
        bottom: ${props => props.$showCaption ? '180px' : '20px'};
        left: 25px;
        position: absolute;
        z-index: 11;
    }
    @media (min-width: 1281px) {
        font-size: 14px;
    }
`;

export const CaptionContent = styled.div`
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 15px;
    justify-content: center;
    margin-left: 10px;
    transition: width 0.3s, max-height 1s, opacity 1s;
    width: ${props => (props.$showCaption ? '100%' : '0px')};
    max-height: ${props => (props.$showCaption ? '300px' : '0px')};
    opacity: ${props => (props.$showCaption ? '1' : '0')};
    overflow: ${props => (props.$showCaption ? '' : 'hidden')};
    @media (min-width: 720px) {
        justify-content: flex-start;
    }
`;

export const CaptionItem = styled.div`
    align-items: center;
    background: #FFF;
    border-radius: 3.676px;
    box-shadow: 1.52px 1.52px 1.52px 0px rgba(0, 0, 0, 0.25);
    color: #333;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    gap: 8px;
    justify-content: flex-start;
    line-height: normal;
    padding: 5px;
    @media (min-width: 720px) {
        height: 40px;
        padding: 0px;
        padding-inline: 5px;
    }
    @media (min-width: 1281px) {
        font-size: 15px;
    }
`;

export const CaptionImg = styled.img`
    align-items: center;
    display: flex;
    height: 18px;
    justify-content: center;
    width: 18px;
    @media (min-width: 1281px) {
        height: 20px;
        width: 20px;
    }
`;

export const CaptionImage = styled.img`
    display: flex;
    height: ${props => props.$height};
    width: ${props => props.$width};
`;


export const LastUpdateEquipament = styled.span`
    background: #FFF;
    border-radius: 5px;
    box-shadow: 0px 1.52px 1.52px 0px rgba(0, 0, 0, 0.25);
    color: #333;
    display: flex;
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    gap: 10px;
    justify-content: center;
    line-height: normal;
    margin-top: 15px;
    padding: 6px 9px;
    text-align: center;
`;

export const ButtonIcon = styled(SVG)`
    align-self: center;
    height: 20px;
    width: 20px;
    & path {
        fill: ${({ fill }) => fill};
    }
    @media (min-width: 1281px) {
        height: 30px;
        width: 30px;
    }
`;

export const WaveLeft = styled.div`
  position: absolute;
  left: 15px;
  background-image: url(${Wave2});
  background-repeat: repeat-y;
  width: 65px;
  height: 100%;
  top: 0;
  overflow: hidden;
`;

export const WaveRight = styled.div`
  position: absolute;
  right: 15px;
  background-image: url(${Wave1});
  background-repeat: repeat-y;
  width: 65px;
  height: 100%;
  top: 0;
  overflow: hidden;
`;

export const NewDesignText = styled.p`
    text-align: center;
    font-size: 10px;
    @media (min-width: 768px) {
        font-size: 15px;
        padding-inline: 40px;
    }
    @media (min-width: 1200px) {
        font-size: 16px;
        padding-block: 8px;
    }
`

export const NewDesignTitle = styled.h1`
    text-align: center;
    font-size: 12px;
    font-weight: bold;
    @media (min-width: 768px) {
        font-size: 20px;
    }
    @media (min-width: 1200px) {
        font-size: 28px;
    }
`;